import { render, staticRenderFns } from "./DatatableMaterials.vue?vue&type=template&id=6a66d087"
import script from "./DatatableMaterials.vue?vue&type=script&lang=js"
export * from "./DatatableMaterials.vue?vue&type=script&lang=js"
import style0 from "./DatatableMaterials.vue?vue&type=style&index=0&id=6a66d087&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports